// extracted by mini-css-extract-plugin
export default {"container":"Services_container__oJ1FV","subheading":"Services_subheading__y-SBZ","secondary":"Services_secondary__QcvIF","grid":"Services_grid__Ramz+","item":"Services_item__gRUZK"};